// src/pages/SupportFaqs.jsx
// Gestión de FAQs del bot (admin/leader). Rediseño 2026-05-13. Lógica 1:1.
import React, { useEffect, useState } from 'react';
import { Spinner, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import api from '../services/api';


const Icon = ({ children, size = 16, stroke = 1.75 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
         stroke="currentColor" strokeWidth={stroke}
         strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
        {children}
    </svg>
);
const I = {
    search:  <Icon size={14}><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></Icon>,
    refresh: <Icon size={14}><path d="M3 12a9 9 0 0 1 15-6.7L21 8" /><path d="M21 3v5h-5" /><path d="M21 12a9 9 0 0 1-15 6.7L3 16" /><path d="M3 21v-5h5" /></Icon>,
    plus:    <Icon size={14}><path d="M12 5v14" /><path d="M5 12h14" /></Icon>,
    check:   <Icon size={14}><path d="M20 6 9 17l-5-5" /></Icon>,
    x:       <Icon size={14}><path d="M18 6 6 18" /><path d="m6 6 12 12" /></Icon>,
    edit:    <Icon size={14}><path d="M12 20h9" /><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" /></Icon>,
    trash:   <Icon size={14}><path d="M3 6h18" /><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" /><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" /></Icon>,
};


const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
/* Tokens de la página. También en .sp-modal: react-bootstrap monta el Modal en
   <body>, fuera de .sp-root, y sin esto los botones del modal quedaban sin color. */
.sp-root, .sp-modal {
    --sp-accent: var(--brand-700, #0a4aa8);
    --sp-accent-hover: var(--brand-800, #07357f);
    --sp-accent-light: #dbeafe;
    --sp-accent-ring: rgba(10, 74, 168, .12);
}
.sp-root {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif;
    -webkit-font-smoothing: antialiased;
    max-width: 1100px; margin: 0 auto; padding: 24px 20px 60px;
    color: var(--c-text-1);
}
.sp-root * { box-sizing: border-box; }
.sp-title { font-size: 24px; font-weight: 700; margin: 0 0 4px; letter-spacing: -0.01em; }
.sp-subtitle { color: var(--c-text-3); font-size: 13.5px; margin: 0 0 18px; line-height: 1.5; }

/* Tabs */
.sp-tabs {
    display: inline-flex; gap: 4px; padding: 4px;
    background: var(--c-card);
    border: 1px solid var(--c-border);
    border-radius: 999px;
    margin-bottom: 18px;
}
.sp-tab {
    background: transparent; border: none;
    padding: 7px 18px; border-radius: 999px;
    font-size: 13px; font-weight: 600;
    color: var(--c-text-3);
    cursor: pointer; font-family: inherit;
    transition: all .15s;
}
.sp-tab:hover { color: var(--c-text-1); background: var(--c-msg-bg); }
.sp-tab.active { background: var(--sp-accent); color: #fff; }
.sp-tab.active:hover { background: var(--sp-accent-hover); color: #fff; }

/* Top actions bar */
.sp-actions-bar { display: flex; gap: 8px; align-items: center; margin-bottom: 14px; flex-wrap: wrap; }
.sp-count { margin-left: auto; font-size: 12px; color: var(--c-text-4); }

/* Buttons */
.sp-btn {
    display: inline-flex; align-items: center; gap: 6px;
    border: 1px solid transparent; border-radius: 8px;
    padding: 7px 14px; font-size: 13px; font-weight: 600;
    cursor: pointer; font-family: inherit;
    transition: all .15s;
}
.sp-btn:disabled { opacity: 0.5; cursor: not-allowed; }
.sp-btn.sm { padding: 5px 11px; font-size: 12px; }
.sp-btn-primary { background: var(--sp-accent); color: #fff; border-color: var(--sp-accent); }
.sp-btn-primary:hover:not(:disabled) { background: var(--sp-accent-hover); border-color: var(--sp-accent-hover); }
.sp-btn-success { background: #059669; color: #fff; border-color: #059669; }
.sp-btn-success:hover:not(:disabled) { background: #047857; border-color: #047857; }
.sp-btn-ghost { background: transparent; color: var(--c-text-2); border-color: var(--c-border); }
.sp-btn-ghost:hover:not(:disabled) { background: var(--c-msg-bg); }
.sp-btn-danger { background: transparent; color: #dc2626; border-color: #fecaca; }
.sp-btn-danger:hover:not(:disabled) { background: var(--c-priority-urgent-bg); border-color: #dc2626; }

/* Cards */
.sp-card {
    background: var(--c-card); border: 1px solid var(--c-border);
    border-radius: 12px; padding: 14px 16px;
    box-shadow: 0 1px 2px rgba(15,23,42,.04);
}
.sp-card-inactive { opacity: 0.55; }
.sp-card-edit { border-color: var(--sp-accent); box-shadow: 0 0 0 3px var(--sp-accent-ring); }

.sp-faq-row {
    display: flex; justify-content: space-between; align-items: flex-start; gap: 12px;
}
.sp-faq-q {
    font-weight: 700; font-size: 14.5px; margin: 0 0 6px;
    color: var(--c-text-1); display: flex; gap: 8px; align-items: center; flex-wrap: wrap;
}
.sp-faq-a {
    font-size: 13.5px; color: var(--c-text-2); line-height: 1.55;
    margin: 0; white-space: pre-wrap;
}
.sp-faq-meta { font-size: 11px; color: var(--c-text-4); margin: 8px 0 0; }
.sp-faq-actions { display: flex; flex-direction: column; gap: 6px; flex-shrink: 0; }

.sp-list { display: flex; flex-direction: column; gap: 10px; }

.sp-pill {
    display: inline-flex; align-items: center;
    padding: 1px 8px; border-radius: 999px;
    font-size: 10px; font-weight: 600;
    letter-spacing: 0.2px;
}
.sp-pill-inactive { background: var(--c-msg-bg); color: var(--c-text-3); }
.sp-pill-source   { background: var(--sp-accent-light); color: var(--sp-accent); }

/* Empty state */
.sp-empty {
    text-align: center; padding: 40px;
    background: var(--c-card);
    border: 1px dashed var(--c-border);
    border-radius: 12px;
}
.sp-empty-title { font-size: 14.5px; font-weight: 700; margin: 0 0 6px; color: var(--c-text-1); }
.sp-empty-sub   { font-size: 12.5px; color: var(--c-text-4); margin: 0; }

/* Create form (active tab) */
.sp-create {
    background: var(--c-status-open-bg);
    border: 1px solid #93c5fd;
    border-radius: 12px;
    padding: 14px 16px;
    margin-bottom: 16px;
}
[data-bs-theme="dark"] .sp-create { background: rgba(37,99,235,.08); border-color: rgba(37,99,235,.3); }
.sp-create-title { font-size: 13.5px; font-weight: 700; color: var(--c-text-1); margin: 0 0 10px; }
.sp-textarea {
    width: 100%; padding: 9px 12px;
    font-size: 13.5px; font-family: inherit; line-height: 1.5;
    border: 1px solid var(--c-border); border-radius: 8px;
    background: var(--c-card); color: var(--c-text-1);
    outline: none; resize: vertical;
    transition: border-color .15s, box-shadow .15s;
}
.sp-textarea:focus { border-color: var(--sp-accent); box-shadow: 0 0 0 3px var(--sp-accent-ring); }
.sp-input-small {
    padding: 6px 10px; font-size: 13px;
    border: 1px solid var(--c-border); border-radius: 8px;
    background: var(--c-card); color: var(--c-text-1);
    font-family: inherit; outline: none; max-width: 100px;
    transition: border-color .15s, box-shadow .15s;
}
.sp-input-small:focus { border-color: var(--sp-accent); box-shadow: 0 0 0 3px var(--sp-accent-ring); }
.sp-create-footer { display: flex; gap: 10px; margin-top: 8px; align-items: center; }
.sp-switch-label {
    display: inline-flex; align-items: center; gap: 6px;
    font-size: 13px; color: var(--c-text-2); cursor: pointer;
}
.sp-switch-label input { accent-color: var(--sp-accent); }

/* Modal inner customizations */
.modal-content { background: var(--c-card) !important; border: 1px solid var(--c-border) !important; }
.sp-modal-label {
    font-size: 12px; font-weight: 600; color: var(--c-text-2);
    margin-bottom: 4px; display: block;
}
.sp-modal-hint { font-size: 11px; color: var(--c-text-4); margin: 4px 0 0; }

.sp-dept-list {
    max-height: 160px; overflow-y: auto;
    background: var(--c-input-bg);
    border: 1px solid var(--c-border);
    border-radius: 8px; padding: 8px;
}
.sp-dept-list label {
    display: block; padding: 3px 4px; font-size: 13px;
    cursor: pointer;
}
.sp-dept-list label input { margin-right: 6px; accent-color: var(--sp-accent); }
.sp-info-box {
    background: var(--sp-accent-light); border: 1px solid #93c5fd;
    border-radius: 8px; padding: 12px;
}
[data-bs-theme="dark"] .sp-info-box { background: rgba(37,99,235,.08); border-color: rgba(37,99,235,.3); }
.sp-info-box strong { display: block; font-size: 12px; margin-bottom: 8px; }
`;


// ── Componente principal ────────────────────────────────────────────────────
export default function SupportFaqs() {
    const [tab, setTab] = useState('pending');
    return (
        <>
            <style>{CSS}</style>
            <div className="sp-root">
                <h1 className="sp-title">FAQs del bot</h1>
                <p className="sp-subtitle">
                    Las FAQs <strong>activas</strong> se inyectan automáticamente al system prompt del bot.
                    Las <strong>candidatas</strong> salen del job de extracción (analiza tickets cerrados con IA)
                    y esperan tu revisión.
                </p>

                <div className="sp-tabs">
                    <button type="button" className={`sp-tab${tab === 'pending' ? ' active' : ''}`} onClick={() => setTab('pending')}>
                        Pendientes
                    </button>
                    <button type="button" className={`sp-tab${tab === 'active' ? ' active' : ''}`} onClick={() => setTab('active')}>
                        Activas
                    </button>
                </div>

                {tab === 'pending' && <CandidatesTab />}
                {tab === 'active'  && <ActiveFaqsTab />}
            </div>
        </>
    );
}


// ── Pendientes ──────────────────────────────────────────────────────────────
function CandidatesTab() {
    const [list, setList]     = useState([]);
    const [loading, setLoading] = useState(true);
    const [extracting, setExtracting] = useState(false);
    const [showExtract, setShowExtract] = useState(false);
    const [editing, setEditing] = useState(null);

    const reload = async () => {
        setLoading(true);
        try {
            const { data } = await api.get('/support/faqs/candidates', { params: { status: 'pending' } });
            setList(data || []);
        } catch (e) { toast.error(e.response?.data?.error || 'Error al cargar'); }
        finally { setLoading(false); }
    };

    useEffect(() => { reload(); }, []);

    const runExtract = async (params) => {
        setExtracting(true);
        setShowExtract(false);
        try {
            const { data } = await api.post('/support/faqs/extract', params, { timeout: 5 * 60 * 1000 });
            const sc = data.scanned   || {};
            const pr = data.processed || {};
            const detail = `convs ${pr.conversations || 0}/${sc.conversations || 0} · tickets ${pr.tickets || 0}/${sc.tickets || 0}`;
            toast.success(
                `Extracción OK · ${data.candidatesCreated} candidatas (${detail}, ${data.tokensUsed.toLocaleString()} tokens)`,
                { autoClose: 8000 },
            );
            reload();
        } catch (e) {
            const isTimeout = e.code === 'ECONNABORTED' || /timeout/i.test(e.message || '');
            toast.error(
                isTimeout
                    ? 'La extracción tardó más del timeout — puede haber completado igual; recargá el tab en un minuto'
                    : (e.response?.data?.error || 'No se pudo extraer'),
                { autoClose: 8000 },
            );
        } finally { setExtracting(false); }
    };

    const reject = async (cand) => {
        const reason = window.prompt('Motivo del rechazo (opcional):', '');
        if (reason === null) return;
        try {
            await api.post(`/support/faqs/candidates/${cand._id}/reject`, { reason });
            setList(prev => prev.filter(c => c._id !== cand._id));
            toast.info('Candidata rechazada');
        } catch (e) { toast.error(e.response?.data?.error || 'Error'); }
    };

    return (
        <>
            <div className="sp-actions-bar">
                <button type="button" className="sp-btn sp-btn-primary" disabled={extracting} onClick={() => setShowExtract(true)}>
                    {extracting ? <><Spinner size="sm" animation="border" /> Extrayendo…</> : <>{I.search} Extraer ahora</>}
                </button>
                <button type="button" className="sp-btn sp-btn-ghost" onClick={reload} disabled={loading}>
                    {I.refresh} Recargar
                </button>
                <span className="sp-count">{list.length} pendiente{list.length === 1 ? '' : 's'}</span>
            </div>

            {loading ? (
                <div style={{ textAlign: 'center', padding: 60 }}><Spinner animation="border" variant="primary" /></div>
            ) : list.length === 0 ? (
                <div className="sp-empty">
                    <p className="sp-empty-title">Sin candidatas pendientes</p>
                    <p className="sp-empty-sub">Corre "Extraer ahora" para que la IA analice tickets cerrados y proponga FAQs.</p>
                </div>
            ) : (
                <div className="sp-list">
                    {list.map(c => (
                        <CandidateCard key={c._id} cand={c}
                            onApprove={() => setEditing(c)}
                            onReject={() => reject(c)} />
                    ))}
                </div>
            )}

            <ExtractModal show={showExtract} onClose={() => setShowExtract(false)} onRun={runExtract} />
            <ApproveModal cand={editing} onClose={() => setEditing(null)} onDone={() => { setEditing(null); reload(); }} />
        </>
    );
}


function CandidateCard({ cand, onApprove, onReject }) {
    const sourceLabel = (cand.sourceTickets || []).map(t => `#${t.folio || ''}`).filter(Boolean).join(', ')
        || (cand.sourceConversations || []).map(c => c.snapshot?.name).filter(Boolean).join(', ')
        || '—';
    return (
        <div className="sp-card">
            <div className="sp-faq-row">
                <div style={{ flex: 1, minWidth: 0 }}>
                    <p className="sp-faq-q">{cand.question}</p>
                    <p className="sp-faq-a">{cand.answer}</p>
                    <p className="sp-faq-meta">
                        Origen: {sourceLabel} · {new Date(cand.createdAt).toLocaleString()} · modelo {cand.extractedBy?.model || '?'}
                    </p>
                </div>
                <div className="sp-faq-actions">
                    <button type="button" className="sp-btn sp-btn-success sm" onClick={onApprove}>{I.check} Aprobar</button>
                    <button type="button" className="sp-btn sp-btn-danger sm" onClick={onReject}>{I.x} Rechazar</button>
                </div>
            </div>
        </div>
    );
}


function ApproveModal({ cand, onClose, onDone }) {
    const [q, setQ] = useState('');
    const [a, setA] = useState('');
    const [order, setOrder] = useState(0);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (cand) { setQ(cand.question || ''); setA(cand.answer || ''); setOrder(0); }
    }, [cand]);

    const save = async () => {
        if (!cand) return;
        setSaving(true);
        try {
            await api.post(`/support/faqs/candidates/${cand._id}/approve`, {
                question: q, answer: a, order: Number(order) || 0,
            });
            toast.success('FAQ aprobada y agregada al bot');
            onDone();
        } catch (e) {
            toast.error(e.response?.data?.error || 'Error al aprobar');
        } finally { setSaving(false); }
    };

    return (
        <Modal className="sp-modal" show={!!cand} onHide={onClose} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title style={{ fontSize: 16, fontWeight: 700 }}>Aprobar FAQ</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p style={{ fontSize: 12.5, color: 'var(--c-text-4)', marginBottom: 14 }}>
                    Edita si querés antes de aprobar. Al guardar, la FAQ pasa a estado activo y se inyecta al bot en ~1 minuto.
                </p>
                <div style={{ marginBottom: 12 }}>
                    <label className="sp-modal-label">Pregunta</label>
                    <textarea rows={2} className="sp-textarea" value={q} onChange={e => setQ(e.target.value)} maxLength={300} />
                    <p className="sp-modal-hint">{q.length}/300</p>
                </div>
                <div style={{ marginBottom: 12 }}>
                    <label className="sp-modal-label">Respuesta</label>
                    <textarea rows={4} className="sp-textarea" value={a} onChange={e => setA(e.target.value)} maxLength={800} />
                    <p className="sp-modal-hint">{a.length}/800</p>
                </div>
                <div>
                    <label className="sp-modal-label">Orden (menor = aparece antes en el prompt)</label>
                    <input type="number" className="sp-input-small" value={order} onChange={e => setOrder(e.target.value)} />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="sp-btn sp-btn-ghost" onClick={onClose}>Cancelar</button>
                <button type="button" className="sp-btn sp-btn-success" onClick={save} disabled={saving || q.trim().length < 8 || a.trim().length < 8}>
                    {saving ? <Spinner size="sm" animation="border" /> : <>{I.check} Aprobar y activar</>}
                </button>
            </Modal.Footer>
        </Modal>
    );
}


const PAISES = ['', 'MEXICO', 'GUATEMALA', 'EL SALVADOR', 'HONDURAS', 'NICARAGUA', 'COLOMBIA', 'PERU'];

function ExtractModal({ show, onClose, onRun }) {
    const [source, setSource]       = useState('both');
    const [sinceDays, setSinceDays] = useState(100);
    const [limit, setLimit]         = useState(50);
    const [pais, setPais]           = useState('');
    const [ticketSource, setTicketSource] = useState('all');
    const [departments, setDepartments] = useState([]);
    const [departmentIds, setDepartmentIds] = useState([]);

    const includesTickets = source === 'both' || source === 'tickets';

    useEffect(() => {
        if (!show || !includesTickets) return;
        if (departments.length) return;
        api.get('/departments')
            .then(r => setDepartments(r.data || []))
            .catch(() => {});
    }, [show, includesTickets, departments.length]);

    const toggleDept = (id) => {
        setDepartmentIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
    };
    const allDeptsSelected = departmentIds.length === 0;

    return (
        <Modal className="sp-modal" show={show} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title style={{ fontSize: 16, fontWeight: 700 }}>Extraer FAQs</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p style={{ fontSize: 13, color: 'var(--c-text-4)', marginBottom: 14 }}>
                    Analiza casos cerrados y propone FAQs candidatas. Tarda ~1-3 seg por caso. Usa OpenAI (cuesta tokens).
                </p>

                <div style={{ marginBottom: 14 }}>
                    <label className="sp-modal-label">Fuente</label>
                    <select className="sp-textarea" style={{ resize: 'none' }} value={source} onChange={e => setSource(e.target.value)}>
                        <option value="both">Conversaciones del bot + Tickets cerrados (recomendado)</option>
                        <option value="tickets">Solo Tickets cerrados (Presico, marcas, staff)</option>
                        <option value="support">Solo conversaciones del bot</option>
                    </select>
                    <p className="sp-modal-hint">El límite de abajo se aplica por cada fuente seleccionada.</p>
                </div>

                <div style={{ display: 'flex', gap: 12, marginBottom: 14 }}>
                    <div style={{ flex: 1 }}>
                        <label className="sp-modal-label">Días hacia atrás</label>
                        <input type="number" className="sp-textarea" style={{ resize: 'none' }} value={sinceDays} min={1} max={3650}
                            onChange={e => setSinceDays(Number(e.target.value) || 100)} />
                        <p className="sp-modal-hint">Por closedAt. Default 100.</p>
                    </div>
                    <div style={{ flex: 1 }}>
                        <label className="sp-modal-label">Máx por fuente</label>
                        <input type="number" className="sp-textarea" style={{ resize: 'none' }} value={limit} min={1} max={200}
                            onChange={e => setLimit(Number(e.target.value) || 50)} />
                        <p className="sp-modal-hint">Tope de costo. Máx 200.</p>
                    </div>
                </div>

                {includesTickets && (
                    <div className="sp-info-box">
                        <strong>Filtros para tickets</strong>
                        <div style={{ marginBottom: 10 }}>
                            <label className="sp-modal-label">País</label>
                            <select className="sp-textarea" style={{ resize: 'none' }} value={pais} onChange={e => setPais(e.target.value)}>
                                {PAISES.map(p => <option key={p || 'any'} value={p}>{p || '— Todos —'}</option>)}
                            </select>
                        </div>
                        <div style={{ marginBottom: 10 }}>
                            <label className="sp-modal-label">Origen del ticket</label>
                            <select className="sp-textarea" style={{ resize: 'none' }} value={ticketSource} onChange={e => setTicketSource(e.target.value)}>
                                <option value="all">Todos</option>
                                <option value="presico">Solo de la app Presico</option>
                                <option value="staff">Solo creados por staff</option>
                            </select>
                        </div>
                        <div>
                            <label className="sp-modal-label">
                                Departamentos
                                {' '}<span style={{ fontWeight: 400, color: 'var(--c-text-4)' }}>
                                    ({allDeptsSelected ? 'todos' : `${departmentIds.length} seleccionado${departmentIds.length === 1 ? '' : 's'}`})
                                </span>
                                {!allDeptsSelected && (
                                    <button type="button" onClick={() => setDepartmentIds([])}
                                        style={{ background: 'none', border: 'none', color: 'var(--sp-accent)', padding: 0, marginLeft: 8, fontSize: 11, cursor: 'pointer', fontFamily: 'inherit' }}>
                                        limpiar
                                    </button>
                                )}
                            </label>
                            {departments.length === 0 ? (
                                <div style={{ fontSize: 12, color: 'var(--c-text-4)', fontStyle: 'italic' }}>
                                    Cargando departamentos…
                                </div>
                            ) : (
                                <div className="sp-dept-list">
                                    {departments.map(d => (
                                        <label key={d._id}>
                                            <input
                                                type="checkbox"
                                                checked={departmentIds.includes(d._id)}
                                                onChange={() => toggleDept(d._id)}
                                            />
                                            {d.name}
                                        </label>
                                    ))}
                                </div>
                            )}
                            <p className="sp-modal-hint">
                                Sin selección = todos los departamentos. Recomendado: marca solo los de Atención a Clientes para evitar tickets internos.
                            </p>
                        </div>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="sp-btn sp-btn-ghost" onClick={onClose}>Cancelar</button>
                <button type="button" className="sp-btn sp-btn-primary" onClick={() => onRun({ source, sinceDays, limit, pais, ticketSource, departmentIds })}>
                    Lanzar extracción
                </button>
            </Modal.Footer>
        </Modal>
    );
}


// ── Activas ─────────────────────────────────────────────────────────────────
function ActiveFaqsTab() {
    const [list, setList]     = useState([]);
    const [loading, setLoading] = useState(true);
    const [creating, setCreating] = useState(false);
    const [draft, setDraft] = useState({ question: '', answer: '', order: 0, active: true });

    const reload = async () => {
        setLoading(true);
        try {
            const { data } = await api.get('/support/faqs');
            setList(data || []);
        } catch (e) { toast.error(e.response?.data?.error || 'Error al cargar'); }
        finally { setLoading(false); }
    };

    useEffect(() => { reload(); }, []);

    const create = async () => {
        if (draft.question.trim().length < 8 || draft.answer.trim().length < 8) {
            toast.warn('Pregunta y respuesta deben tener al menos 8 caracteres');
            return;
        }
        setCreating(true);
        try {
            const { data } = await api.post('/support/faqs', draft);
            setList(prev => [data, ...prev]);
            setDraft({ question: '', answer: '', order: 0, active: true });
            toast.success('FAQ creada');
        } catch (e) { toast.error(e.response?.data?.error || 'Error'); }
        finally { setCreating(false); }
    };

    const update = async (id, patch) => {
        try {
            const { data } = await api.patch(`/support/faqs/${id}`, patch);
            setList(prev => prev.map(f => f._id === id ? data : f));
        } catch (e) { toast.error(e.response?.data?.error || 'Error'); }
    };

    const remove = async (id) => {
        if (!window.confirm('¿Eliminar esta FAQ definitivamente?')) return;
        try {
            await api.delete(`/support/faqs/${id}`);
            setList(prev => prev.filter(f => f._id !== id));
            toast.success('Eliminada');
        } catch (e) { toast.error(e.response?.data?.error || 'Error'); }
    };

    return (
        <>
            <div className="sp-create">
                <p className="sp-create-title">{I.plus} Nueva FAQ manual</p>
                <textarea rows={1} className="sp-textarea" placeholder="Pregunta (ej: ¿Cómo cambio mi domicilio?)"
                    value={draft.question} onChange={e => setDraft(d => ({ ...d, question: e.target.value }))}
                    maxLength={300}
                    style={{ marginBottom: 8 }} />
                <textarea rows={2} className="sp-textarea" placeholder="Respuesta"
                    value={draft.answer} onChange={e => setDraft(d => ({ ...d, answer: e.target.value }))}
                    maxLength={800} />
                <div className="sp-create-footer">
                    <input type="number" className="sp-input-small" value={draft.order}
                        onChange={e => setDraft(d => ({ ...d, order: Number(e.target.value) || 0 }))}
                        placeholder="Orden" />
                    <label className="sp-switch-label">
                        <input type="checkbox" checked={draft.active}
                            onChange={e => setDraft(d => ({ ...d, active: e.target.checked }))} />
                        Activa
                    </label>
                    <button type="button" className="sp-btn sp-btn-success sm" onClick={create} disabled={creating} style={{ marginLeft: 'auto' }}>
                        {creating ? <Spinner size="sm" animation="border" /> : <>{I.plus} Crear</>}
                    </button>
                </div>
            </div>

            {loading ? (
                <div style={{ textAlign: 'center', padding: 60 }}><Spinner animation="border" variant="primary" /></div>
            ) : list.length === 0 ? (
                <div className="sp-empty">
                    <p className="sp-empty-title">Sin FAQs activas</p>
                    <p className="sp-empty-sub">Aprobá candidatas o creá una manual arriba.</p>
                </div>
            ) : (
                <div className="sp-list">
                    {list.map(f => <FaqRow key={f._id} faq={f} onUpdate={update} onDelete={remove} />)}
                </div>
            )}
        </>
    );
}


function FaqRow({ faq, onUpdate, onDelete }) {
    const [editing, setEditing] = useState(false);
    const [draft, setDraft] = useState({ question: faq.question, answer: faq.answer, order: faq.order || 0 });

    useEffect(() => { setDraft({ question: faq.question, answer: faq.answer, order: faq.order || 0 }); }, [faq]);

    if (editing) {
        return (
            <div className="sp-card sp-card-edit">
                <textarea rows={1} className="sp-textarea" value={draft.question}
                    onChange={e => setDraft(d => ({ ...d, question: e.target.value }))} maxLength={300}
                    style={{ marginBottom: 8 }} />
                <textarea rows={3} className="sp-textarea" value={draft.answer}
                    onChange={e => setDraft(d => ({ ...d, answer: e.target.value }))} maxLength={800} />
                <div style={{ display: 'flex', gap: 8, marginTop: 10, alignItems: 'center' }}>
                    <input type="number" className="sp-input-small" value={draft.order}
                        onChange={e => setDraft(d => ({ ...d, order: Number(e.target.value) || 0 }))} />
                    <button type="button" className="sp-btn sp-btn-success sm" onClick={() => { onUpdate(faq._id, draft); setEditing(false); }}>
                        {I.check} Guardar
                    </button>
                    <button type="button" className="sp-btn sp-btn-ghost sm" onClick={() => setEditing(false)}>
                        Cancelar
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className={`sp-card${!faq.active ? ' sp-card-inactive' : ''}`}>
            <div className="sp-faq-row">
                <div style={{ flex: 1, minWidth: 0 }}>
                    <p className="sp-faq-q">
                        {faq.question}
                        {!faq.active && <span className="sp-pill sp-pill-inactive">inactiva</span>}
                        {faq.sourceCandidate && <span className="sp-pill sp-pill-source">de candidata</span>}
                    </p>
                    <p className="sp-faq-a">{faq.answer}</p>
                    <p className="sp-faq-meta">
                        Orden: {faq.order || 0}
                        {faq.updatedBy?.name && ` · editada por ${faq.updatedBy.name}`}
                        {' · '}{new Date(faq.updatedAt).toLocaleString()}
                    </p>
                </div>
                <div className="sp-faq-actions">
                    <label className="sp-switch-label" style={{ justifyContent: 'flex-end' }}>
                        <input type="checkbox" checked={faq.active}
                            onChange={e => onUpdate(faq._id, { active: e.target.checked })} />
                        Activa
                    </label>
                    <button type="button" className="sp-btn sp-btn-ghost sm" onClick={() => setEditing(true)}>
                        {I.edit} Editar
                    </button>
                    <button type="button" className="sp-btn sp-btn-danger sm" onClick={() => onDelete(faq._id)}>
                        {I.trash} Eliminar
                    </button>
                </div>
            </div>
        </div>
    );
}
